import script from "./RegisterSettingPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegisterSettingPage.vue?vue&type=script&lang=ts&setup=true"

import "./RegisterSettingPage.vue?vue&type=style&index=0&id=af03adda&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-af03adda"]])

export default __exports__